




































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {
  商品追加候補検索条件型,
  商品追加検索結果一覧型,
  商品追加検索結果型,
  商品追加発注候補型,
  発注卸型,
  発注未確定登録レコード型,
  発注未確定登録型,
  発注未確定登録結果型,
  発注未確定重複レコード型,
} from '@/type/purchaseorder/item';
import {マスタ選択区分型, 商品オンライン発注可否区分, 発注入力方法区分型, 発注未確定登録区分, 発注未確定登録結果区分, 発注重複表示区分} from '@/type/purchaseorder/types';
import {検索並び順区分型, 卸を抜いた検索並び順区分一覧, 検索並び順区分一覧} from '@/type/purchaseorder/検索並び順区分型';
import api from '@/infrastructure/api/api';
import {progress} from '@/script/progress';
import {loginModule} from '@/store/authentication/login';

import {ValidationResult} from '@/type/validation/result';
import {商品追加検索条件バリデータ一覧, 発注情報バリデータ一覧} from '@/type/purchaseorder/order-validate';

import AmountField from '@/components/atom/input/AmountField.vue';
import NormalDialog from '@/components/atom/dialog/NormalDialog.vue';
import WholesaleSelectorPurchaseOrder from '@/components/wholesale/WholesaleSelectorPurchaseOrder.vue';
import DuplicateWarningDialog from '@/views/purchaseorder/DuplicateWarningDialog.vue';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';

@Component({
    components: {
      AmountField,
      NormalDialog,
      WholesaleSelectorPurchaseOrder,
      DuplicateWarningDialog,
      ConfirmDialog,
      NormalButton,
    },
  })

  export default class ItemSearchDialog extends Vue {
    private 発注候補商品検索条件: 商品追加候補検索条件型 = this.検索条件初期値を取得();
    private 発注候補商品リスト: 商品追加発注候補型[] = [];
    private 発注未確定登録リスト: 発注未確定登録レコード型[] = [];
    private 発注重複商品リスト: 発注未確定重複レコード型[] = [];

    private 選択中の行index: number | null = null;
    private 次の行index: number | null = null;
    private グリッド最終行: number | null = null;
    private グリッド件数: number | null = null;

    private 警告画面表示: boolean = false;
    private 警告画面表示モード: string = 発注重複表示区分.発注未確定登録;

    private 検索条件バリデーション結果: ValidationResult = new ValidationResult(商品追加検索条件バリデータ一覧);
    private 発注候補バリデーション結果: ValidationResult = new ValidationResult(発注情報バリデータ一覧);
    private 発注未確定登録バリデーション結果: ValidationResult = new ValidationResult(発注情報バリデータ一覧);

    private beforeOpened: boolean = false;

    @Prop({default: false})
    private modal!: boolean;

    @Prop({default: []})
    private wholesaleList!: 発注卸型[];

    @Watch('発注候補商品リスト.JANコード', {deep: true})
    private 数量にフォーカス(): void {
      this.$nextTick(() => {
        this.グリッド件数 = this.発注候補商品リスト.length;
        if (this.beforeOpened === true && this.グリッド件数 > 0) {
          this.入力欄を指定().数量入力欄[0].$el.childNodes[0].focus();
          this.リスト選択時の処理(0);
        }
      });
    }

    private beforeOpen() {
      const 商品名カナ入力欄 = document.getElementById('商品名カナ');
      if (商品名カナ入力欄) {
        商品名カナ入力欄.focus();
      }
      this.beforeOpened = true;
    }

    private beforeUpdate(): void {
      this.検索条件バリデーション結果.validate(this.発注候補商品検索条件);
      this.発注候補バリデーション結果.validateList(this.発注候補商品リスト);
    }

    private get 表示件数を取得() {
      return this.発注候補商品リスト.length;
    }

    private 検索開始に移動するハンドラ(keyCode: number, repeat: boolean) {
      if (keyCode !== 13) return;
      if (repeat === true) return;
      const 検索開始ボタン = document.getElementById('検索開始');
      if (!検索開始ボタン) return;
      検索開始ボタン.focus();
    }

    private 検索条件入力エラー判定表示(項目名: string) {
      return {'input-error': this.検索条件バリデーション結果.hasError(項目名)};
    }

    private 発注候補エラー判定(index: number, 項目名: string): boolean {
      if (!this.発注候補商品リスト[index].選択) {
        return false;
      } else {
        return this.発注候補バリデーション結果.hasError(項目名, index);
      }
    }

    private async 確定するハンドラ() {
      await progress(this.確定する);
    }

    private async 確定する(): Promise<void> {

      const 発注未確定登録リストに追加する対象 = this.発注未確定登録リストに追加する対象();
      if (this.発注未確定登録リスト.length === 0 && 発注未確定登録リストに追加する対象.length === 0) {
        this.$emit('show-alert', '発注する商品が選択されていません');
        return;
      }

      this.発注未確定登録バリデーション結果.validateList(発注未確定登録リストに追加する対象);
      if (this.発注未確定登録バリデーション結果.hasErrors) {
        this.$emit('show-alert', this.発注未確定登録バリデーション結果.getMessages());
        return;
      }

      Array.prototype.push.apply(this.発注未確定登録リスト, 発注未確定登録リストに追加する対象);

      const 発注未確定登録依頼: 発注未確定登録型 = {
        発注未確定登録方法区分: 発注未確定登録区分.重複確認して登録する,
        発注未確定登録レコードリスト: this.発注未確定登録リスト,
      };

      await api.発注候補商品を登録する(発注未確定登録依頼)
        .then((response: 発注未確定登録結果型) => {
          if (response.発注未確定登録結果区分 === 発注未確定登録結果区分.重複登録あり) {
            this.発注重複商品リスト = response.発注未確定重複リスト;
            this.警告画面表示 = true;
          } else {
            this.beforeOpened = false;
            this.$modal.hide('発注商品追加画面');
            this.$emit('finish-item-search');
          }
        }).catch((error: any) => {
          this.$emit('show-alert', error.data.message);
        });
    }

    private async 重複ありで確定するハンドラ() {
      await progress(this.重複ありで確定する);
    }

    private async 重複ありで確定する(): Promise<void> {
      this.警告画面表示 = false;

      const 発注未確定登録依頼: 発注未確定登録型 = {
        発注未確定登録方法区分: 発注未確定登録区分.登録する,
        発注未確定登録レコードリスト: this.発注未確定登録リスト,
      };

      await api.発注候補商品を登録する(発注未確定登録依頼)
        .then((response: 発注未確定登録結果型) => {
          this.beforeOpened = false;
          this.$modal.hide('発注商品追加画面');
          this.$emit('finish-item-search');

        }).catch((error: any) => {
          this.$emit('show-alert', error.data.message);
        });
    }

    private 確認画面に戻る() {
      this.警告画面表示 = false;
      this.発注重複商品リスト = [];
    }

    private 戻る() {
      this.警告画面表示 = false;
      this.beforeOpened = false;
      this.$modal.hide('発注商品追加画面');
      this.$emit('finish-item-search');
    }

    private 商品のオンライン発注不可(発注候補: 商品追加発注候補型): boolean {
      return 発注候補.オンライン発注可否区分 !== 商品オンライン発注可否区分.発注可能;
    }

    private 全選択する() {
      this.選択を全て変更する(true);
    }

    private 全解除する() {
      this.選択を全て変更する(false);
    }

    private 選択を全て変更する(選択: boolean) {
      for (const 発注候補 of this.発注候補商品リスト) {
        発注候補.選択 = 選択;
      }
    }

    @Watch('modal')
    private ダイアログ表示状態変更(nowModal: boolean, prevModal: boolean) {
      if (nowModal === true) {
        this.発注候補商品リスト = [];
        this.発注未確定登録リスト = [];
        this.発注候補商品検索条件 = this.検索条件初期値を取得();
        this.警告画面表示 = false;
        this.発注重複商品リスト = [];
        this.選択中の行index = null;
        this.$modal.show('発注商品追加画面');
      }
    }

    private 検索条件初期値を取得(): 商品追加候補検索条件型 {
      return {
        マスタ選択区分: マスタ選択区分型.採用品,
        卸コード: '',
        検索並び順区分: '商品名',
        商品名カナ: '',
        メーカー名: '',
      };
    }

    private マスタ選択区分一覧を取得(): マスタ選択区分型[] {
      if (loginModule.備蓄品の発注が有効である) {
        return [
          マスタ選択区分型.採用品,
          マスタ選択区分型.医薬品,
          マスタ選択区分型.その他品,
          マスタ選択区分型.備蓄品,
        ];
      }

      return [
        マスタ選択区分型.採用品,
        マスタ選択区分型.医薬品,
        マスタ選択区分型.その他品,
      ];
    }

    private 発注未確定登録リストに追加する対象(): 発注未確定登録レコード型[] {
      return this.発注候補商品リスト.filter((発注候補商品: 商品追加発注候補型) => {
        if (this.発注未確定登録リスト.some((s) => s.JANコード === 発注候補商品.JANコード)) {
          return false;
        }
        return 発注候補商品.選択 === true;
      })
          .map((発注候補商品: 商品追加発注候補型) => {
            return {
              JANコード: 発注候補商品.JANコード,
              販売GTINコード: 発注候補商品.販売GTINコード,
              備蓄商品コード: 発注候補商品.備蓄商品コード,
              商品コード: 発注候補商品.商品コード,
              商品区分: 発注候補商品.商品区分,
              卸コード: 発注候補商品.卸コード,
              発注数: 発注候補商品.発注数,
              発注方法区分: null,
              採用フラグ: 発注候補商品.採用フラグ,
              オンライン発注可否区分: 発注候補商品.オンライン発注可否区分,
              発注入力方法区分: 発注入力方法区分型.商品追加,
              発注伝票番号: null,
              発注伝票行番号: null,
            };
          });
    }

    get 検索並び順区分一覧(): 検索並び順区分型[] {
      if (this.マスタ選択区分が採用品以外()) return 卸を抜いた検索並び順区分一覧;
      return 検索並び順区分一覧;
    }

    private async 検索するハンドラ(repeat: boolean) {
      if (repeat === true) return;
      if (this.検索条件バリデーション結果.hasErrors) {
        this.$emit('show-alert', this.検索条件バリデーション結果.getMessages());
        return;
      }

      await progress(this.検索する);
    }

    private async 確認後の検索するハンドラ() {
      this.ダイアログを閉じる('商品追加選択中確認ダイアログ');
      await progress(this.検索する);
    }

    private async 検索する(): Promise<void> {
      if (this.発注候補商品検索条件.商品名カナ.length < 3 || this.発注候補商品検索条件.商品名カナ.trim().length === 0) {
        this.$emit('show-alert', '商品名カナは3文字以上入力してください');
        return;
      }

      const 発注未確定登録リストに追加する対象 = this.発注未確定登録リストに追加する対象();
      this.発注未確定登録バリデーション結果.validateList(発注未確定登録リストに追加する対象);
      if (this.発注未確定登録バリデーション結果.hasErrors) {
        this.$emit('show-alert', this.発注未確定登録バリデーション結果.getMessages());
        return;
      }

      Array.prototype.push.apply(this.発注未確定登録リスト, 発注未確定登録リストに追加する対象);

      await api.商品追加候補を検索する(this.発注候補商品検索条件)
        .then((response: 商品追加検索結果一覧型) => {
          this.発注候補商品リスト = response.商品追加検索結果レコードリスト.map((取得商品: 商品追加検索結果型) => {
            return {
              選択: this.発注未確定登録リスト.some((s) => s.JANコード === 取得商品.JANコード),
              採用フラグ: 取得商品.採用フラグ,
              商品区分: 取得商品.商品区分,
              メーカー名: 取得商品.メーカー名,
              商品名: 取得商品.商品名,
              規格容量: 取得商品.規格容量,
              発注数: 取得商品.発注数,
              卸コード: 取得商品.卸コード,
              商品コード: 取得商品.商品コード,
              JANコード: 取得商品.JANコード,
              販売GTINコード: 取得商品.販売GTINコード,
              備蓄商品コード: 取得商品.備蓄商品コード,
              オンライン発注可否区分: 取得商品.オンライン発注可否区分,
              採用区分: 取得商品.採用区分,
              経過措置区分: 取得商品.経過措置区分,
            };
          });

          if (this.発注候補商品リスト.length === 0) {
            this.$emit('show-alert', '商品が見つかりませんでした');
            return;
          }

          if (response.アラートメッセージ) {
            this.$emit('show-alert', response.アラートメッセージ);
          }

        }).catch((error: any) => {
          this.$emit('show-alert', error.data.message);
        });
    }

    private マスタ選択区分が採用品以外(): boolean {
      return this.発注候補商品検索条件.マスタ選択区分 !== マスタ選択区分型.採用品;
    }

    private マスタ選択区分変更後の処理() {
      this.発注候補商品検索条件.卸コード = '';

      if (this.マスタ選択区分が採用品以外()
        && this.発注候補商品検索条件.検索並び順区分 === '卸') {
        this.発注候補商品検索条件.検索並び順区分 = '商品名';
      }
    }

    private async リスト選択時の処理(index: number) {
      this.選択中の行index = index;
    }

    private 行が選択されている(index: number) {
      return this.選択中の行index === index;
    }

    private ダイアログを開く(name: string): void {
      this.$modal.show(name);
    }

    private ダイアログを閉じる(name: string): void {
      this.$modal.hide(name);
    }

    private 経過措置状態クラス(index: number, 発注候補商品: 商品追加発注候補型): string {
      if (this.行が選択されている(index)) {
        return 'selected';
      }
      if (発注候補商品.経過措置区分 === '経過措置期間') {
        return '経過措置期間';
      }
      if (発注候補商品.経過措置区分 === '経過措置終了') {
        return '経過措置終了';
      }
      return '';
    }

    private 入力欄を指定(): any {
      return this.$refs;
    }

    private 次の行の数量に移動(index: number, keyupCode: number, repeat: boolean): void {
      if (keyupCode !== 13) return;
      if (repeat === true) return;
      this.次の行index = index + 1;
      this.グリッド最終行 = (this.表示件数を取得) - 1;
      if (this.グリッド最終行 >= this.次の行index) {
        this.入力欄を指定().数量入力欄[this.次の行index].$el.childNodes[0].focus();
        this.リスト選択時の処理(this.次の行index);
      } else {
        this.入力欄を指定().数量入力欄[index].$el.childNodes[0].blur();
      }
      this.数量フォーカス移動時選択チェック(index);
    }

    private 数量フォーカス移動時選択チェック(index: number): void {
      if (this.発注候補商品リスト[index].発注数 > 0) {
        this.発注候補商品リスト[index].選択 = true;
      } else {
        this.発注候補商品リスト[index].選択 = false;
      }
    }

  }

